module.exports = __webpack_public_path__ + "static/media/img_16.70824ad2.JPG";